import { z } from 'zod';
import { idSchema } from './common.js';
import { customValuesSchema } from './fields.js';
import { filterSchema, searchRequestSchema } from './filters.js';
/**
 * Bulk edits (RELAY-947). One request changes up to `BULK_MAX` candidates; each changed
 * candidate gets its own audit row and activity row, all carrying the same operation reason,
 * so "one bulk edit" stays traceable record by record.
 */
export const BULK_MAX = 1000;
/** Which candidates: the ones ticked, or every match of the current view's filter and query. */
export const bulkSelectionSchema = z.union([
    z.object({ ids: z.array(idSchema).min(1).max(BULK_MAX) }),
    z.object({
        query: z.object({
            q: z.string().trim().min(1).max(200).optional(),
            filter: filterSchema.optional(),
        }),
    }),
]);
/**
 * What to set. Tags are not in the candidate model yet, and "add to shortlist" waits for
 * jobs (the ticket's own condition); both join here when their tables exist.
 */
export const candidateBulkPatchSchema = z
    .object({
    ownerId: idSchema.nullable(),
    stage: z.string().trim().min(1).max(100).nullable(),
    status: z.string().trim().min(1).max(100).nullable(),
    custom: customValuesSchema,
})
    .partial()
    .refine((p) => p.ownerId !== undefined ||
    p.stage !== undefined ||
    p.status !== undefined ||
    (p.custom !== undefined && Object.keys(p.custom).length > 0), 'Nothing to change');
export const candidateBulkUpdateSchema = z.object({
    selection: bulkSelectionSchema,
    patch: candidateBulkPatchSchema,
});
export const bulkResultSchema = z.object({
    /** Candidates the selection named. */
    matched: z.number().int(),
    updated: z.number().int(),
    /** Already had the values. */
    unchanged: z.number().int(),
    /** Not changed, with the reason (gone, or no permission to edit that one). */
    skipped: z.array(z.object({ id: idSchema, reason: z.string() })),
});
/**
 * CSV export of the current view (RELAY-947): the search body plus the view's visible columns
 * in display order. Without `columns`, the standard export set and every custom field.
 */
export const exportRequestSchema = searchRequestSchema.extend({
    columns: z.array(z.string().min(1).max(100)).min(1).max(120).optional(),
});
//# sourceMappingURL=bulk.js.map